module.exports = __webpack_public_path__ + "static/media/dallal_thumb_even.4d025538.webp";